import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { LoaderCircle } from 'lucide-react'
import { cn } from '@/lib/cn'

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger'
type Size = 'sm' | 'md' | 'lg' | 'icon'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant
  size?: Size
  loading?: boolean
  leadingIcon?: ReactNode
}

export function Button({ className, variant = 'primary', size = 'md', loading, leadingIcon, children, disabled, ...props }: ButtonProps) {
  return <button className={cn(
    'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[var(--radius-control)] font-semibold transition duration-200 disabled:pointer-events-none disabled:opacity-50',
    variant === 'primary' && 'bg-brand text-white shadow-[0_9px_24px_rgba(111,75,242,.22)] hover:-translate-y-0.5 hover:bg-brand-deep',
    variant === 'secondary' && 'border border-line bg-surface text-ink hover:border-brand/35 hover:bg-brand/5',
    variant === 'ghost' && 'text-muted hover:bg-ink/5 hover:text-ink dark:hover:bg-white/8',
    variant === 'danger' && 'bg-danger text-white hover:brightness-95',
    size === 'sm' && 'h-9 px-3 text-sm', size === 'md' && 'h-11 px-4 text-sm', size === 'lg' && 'h-13 px-6 text-[15px]', size === 'icon' && 'size-10 p-0',
    className,
  )} disabled={disabled || loading} {...props}>
    {loading ? <LoaderCircle className="size-4 animate-spin" /> : leadingIcon}
    {children}
  </button>
}
